import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  const { settings } = useSettings();
  const wa = settings.wa_official_number || "6285147888865";
  const waDisplay = settings.wa_official_display || "0851-4788-8865";
  return (
    <footer className="border-t border-cyan-500/10 mt-10 bg-slate-950/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="text-white font-display font-bold text-lg mb-2">tokoinduk.com</div>
          <div className="text-slate-400 text-xs leading-relaxed">Pasar Induk Digital untuk SPPG, warung, resto, catering, dan toko di seluruh Indonesia.</div>
          <a
            data-testid="footer-wa-official"
            href={`https://wa.me/${wa}?text=${encodeURIComponent("Halo TokoInduk, saya mau pesan bahan pangan")}`}
            target="_blank" rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-emerald-300 hover:text-emerald-200 text-xs font-mono-metric"
          >
            <MessageCircle className="w-3 h-3"/> WA OFFICIAL {waDisplay}
          </a>
        </div>
        <div>
          <div className="text-cyan-300 font-mono-metric text-[10px] uppercase tracking-widest mb-3">Marketplace</div>
          <ul className="space-y-2 text-slate-400 text-xs">
            <li><Link to="/marketplace" className="hover:text-cyan-300">Belanja Produk</Link></li>
            <li><Link to="/register" className="hover:text-cyan-300">Daftar Pembeli</Link></li>
            <li><Link to="/seller/register" className="hover:text-cyan-300">Daftar Seller</Link></li>
            <li><Link to="/sales/register" className="hover:text-cyan-300">Sales Freelance</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-cyan-300 font-mono-metric text-[10px] uppercase tracking-widest mb-3">Bantuan & Kebijakan</div>
          <ul className="space-y-2 text-slate-400 text-xs">
            <li><Link data-testid="footer-faq" to="/faq" className="hover:text-cyan-300">FAQ</Link></li>
            <li><Link data-testid="footer-terms" to="/terms" className="hover:text-cyan-300">Syarat & Ketentuan</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-cyan-300">Kebijakan Privasi</Link></li>
            <li><Link data-testid="footer-return" to="/return" className="hover:text-cyan-300">Kebijakan Pengembalian</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-cyan-300 font-mono-metric text-[10px] uppercase tracking-widest mb-3">Kontak</div>
          <ul className="space-y-2 text-slate-400 text-xs">
            <li>{settings.footer_email || "hello@tokoinduk.com"}</li>
            <li>{settings.footer_phone || "+62 851-4788-8865"}</li>
            <li className="text-slate-600 text-[10px] font-mono-metric mt-4">{settings.footer_contact}</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
